export default {
	errorMessage: 'Sorry, please try again.',
};
